module.exports = __webpack_public_path__ + "img/canada-cardiovascular-diseases-female.28f55140.png";